import { Component } from '@angular/core';

@Component({
  selector: 'app-set-new-password',
  standalone: false,
  templateUrl: './set-new-password.component.html',
  styleUrl: './set-new-password.component.scss'
})
export class SetNewPasswordComponent {

}
